import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import Modal from '../shared/Modal.svelte';
import SegmentedControl from '../shared/SegmentedControl.svelte';
import VolumePicker from '../session/VolumePicker.svelte';
import Button from '../shared/Button.svelte';
import { addToStorage } from '../../lib/services/storage';
import { getSettings } from '../../lib/stores/settings.svelte.ts';
import { getActiveChild } from '../../lib/stores/children.svelte.ts';
import { mlToOz, ozToMl } from '../../lib/utils/units.ts';
import { showToast } from '../shared/Toast.svelte';

var root_1 = $.from_html(`<div class="add-storage svelte-1ujy292np5jsl"><div class="field svelte-1ujy292np5jsl"><label class="svelte-1ujy292np5jsl">Location</label> <!></div> <div class="field svelte-1ujy292np5jsl"><label class="svelte-1ujy292np5jsl">Volume</label> <!></div> <!></div>`);

function AddToStorage($$anchor, $$props) {
	$.push($$props, true);

	let initialVolume = $.prop($$props, 'initialVolume', 3, 60);
	const settings = $.derived(getSettings);
	const isImperial = $.derived(() => $.get(settings).units === 'imperial');
	let location = $.state('fridge');

	// Internal volume in mL — synced from initialVolume each time modal opens
	let volumeMl = $.state($.proxy(initialVolume()));

	$.user_effect(() => {
		if ($$props.open) $.set(volumeMl, initialVolume());
	});

	const displayVolume = $.derived(() => $.get(isImperial) ? mlToOz($.get(volumeMl)) : $.get(volumeMl));

	function handleVolumeChange(v) {
		$.set(volumeMl, $.get(isImperial) ? ozToMl(v) : v, true);
	}

	const locationOptions = [
		{ value: 'fridge', label: 'Fridge' },
		{ value: 'freezer', label: 'Freezer' },
		{ value: 'deep-freezer', label: 'Deep Freezer' }
	];

	async function handleSave() {
		const activeChild = getActiveChild();

		if (!activeChild) {
			showToast('No active child selected.', 'error');

			return;
		}

		try {
			await addToStorage(activeChild.id, {
				sessionId: $$props.sessionId,
				location: $.get(location),
				volumeMl: $.get(volumeMl)
			});

			$$props.onsaved?.();
			$$props.onclose();
		} catch(e) {
			showToast('Failed to save to storage. Please try again.', 'error');
		}
	}

	var fragment = $.comment();
	var node = $.first_child(fragment);

	Modal(node, {
		get open() {
			return $$props.open;
		},

		get onclose() {
			return $$props.onclose;
		},
		title: 'Add to Storage',
		children: ($$anchor, $$slotProps) => {
			var div = root_1();
			var div_1 = $.child(div);
			var node_1 = $.sibling($.child(div_1), 2);

			SegmentedControl(node_1, {
				get options() {
					return locationOptions;
				},

				get selected() {
					return $.get(location);
				},
				onchange: (v) => $.set(location, v, true)
			});

			$.reset(div_1);

			var div_2 = $.sibling(div_1, 2);
			var node_2 = $.sibling($.child(div_2), 2);

			{
				let $0 = $.derived(() => $.get(isImperial) ? 'oz' : 'mL');
				let $1 = $.derived(() => $.get(isImperial) ? 0.5 : 5);
				let $2 = $.derived(() => $.get(isImperial) ? 17 : 500);

				VolumePicker(node_2, {
					get value() {
						return $.get(displayVolume);
					},
					onchange: handleVolumeChange,
					get unit() {
						return $.get($0);
					},

					get step() {
						return $.get($1);
					},

					get max() {
						return $.get($2);
					}
				});
			}

			$.reset(div_2);

			var node_3 = $.sibling(div_2, 2);

			Button(node_3, {
				variant: 'primary',
				fullWidth: true,
				onclick: handleSave,
				children: ($$anchor, $$slotProps) => {
					$.next();

					var text = $.text('Save to Storage');

					$.append($$anchor, text);
				},
				$$slots: { default: true }
			});

			$.reset(div);
			$.append($$anchor, div);
		},
		$$slots: { default: true }
	});

	$.append($$anchor, fragment);
	$.pop();
}

if (import.meta.hot) {
	AddToStorage = $.hmr(AddToStorage);

	import.meta.hot.accept((module) => {
		$.cleanup_styles('svelte-1ujy292np5jsl');
		AddToStorage[$.HMR].update(module.default);
	});
}

export default AddToStorage;
import "bun-svelte:AddToStorage.svelte-ehapbjqxpqad-style.css";